/**
 * Created by DynamicDog on 2016-12-03.
 *
 * Simple toggle-header with an optional delete button (only if more than one etikett)
 * TODO: Add alert when deleting an etikett
 */
import {Component, Input} from '@angular/core';
import {EtikettService} from "../services/etikett.service";

@Component({
    selector: 'etikett-header',
    template: `
        <div id="etikettHeader{{index}}"></div>
        <div class="etikett-header-background">
            <div class="etikett-header">
                <div *ngIf="isOpen()" class="clickable" style="width:24px;display:inline-block">-</div>
                <div *ngIf="!isOpen()" class="clickable" style="width:24px;display:inline-block">+</div>
                <span class="clickable">{{'Etikett'|translate}} {{index+1}}</span>
                <div class="clickable" style="float:right;padding-left:calc(1vw);margin-top:-4px;" *ngIf="etikettService.getEtiketter().length > 1" (click)="onDelete()"><img height="20px" src="css/images/soptunna.png"></div>
            </div>
        </div>
`,
})
export class EtikettHeaderComponent {
    @Input() index:number;

    constructor(private etikettService:EtikettService) {

    }

    // Check if the view is extended or not
    private isOpen() {
        return this.etikettService.getEtikett(this.index).open;
    }

    private onDelete() {
        this.etikettService.removeEtikett(this.index);
    }
}


// WEBPACK FOOTER //
// ./app/etikett/etikettheader.component.ts